import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["children", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.object.keys.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import transitionInfo from 'dom-helpers/transition/properties';
import addEventListener from 'dom-helpers/events/on';
import classnames from 'classnames';
import PropTypes from 'prop-types';
var transitionEndEvent = transitionInfo.end; //设置状态码

export var UNMOUNTED = 0;
export var EXITED = 1;
export var ENTERING = 2;
export var ENTERED = 3;
export var EXITING = 4;
var propTypes = {
  /**
   * 是否触发动画
   */
  in: PropTypes.bool,

  /**
   * 不显示的时候是否移除组件
   */
  unmountOnExit: PropTypes.bool,

  /**
   * 如果设置为默认显示，挂载时显示动画
   */
  transitionAppear: PropTypes.bool,

  /**
   * 设置超时时间，防止出现问题，可设置为>=动画时间
   */
  timeout: PropTypes.number,

  /**
   * 退出组件时添加的class
   */
  exitedClassName: PropTypes.string,

  /**
   * 退出组件中添加的class
   */
  exitingClassName: PropTypes.string,

  /**
   * 进入动画后添加的class
   */
  enteredClassName: PropTypes.string,

  /**
   * 进入动画时添加的class
   */
  enteringClassName: PropTypes.string,

  /**
   * 进入动画开始时的钩子函数
   */
  onEnter: PropTypes.func,

  /**
   * 进入动画中的钩子函数
   */
  onEntering: PropTypes.func,

  /**
   * 进入动画后的钩子函数
   */
  onEntered: PropTypes.func,

  /**
   * 退出动画开始时的钩子函数
   */
  onExit: PropTypes.func,

  /**
   * 退出动画中的钩子函数
   */
  onExiting: PropTypes.func,

  /**
   * 退出动画后的钩子函数
   */
  onExited: PropTypes.func
};

function noop() {}

var defaultProps = {
  in: false,
  unmountOnExit: false,
  transitionAppear: false,
  timeout: 5000,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
/**
 * 动画组件
 */

var Transition = /*#__PURE__*/function (_Component) {
  _inherits(Transition, _Component);

  var _super = _createSuper(Transition);

  function Transition(props, context) {
    var _this;

    _classCallCheck(this, Transition);

    _this = _super.call(this, props, context);
    var initialStatus;

    if (props.in) {
      // 在componentdidmount时开始执行动画
      initialStatus = props.transitionAppear ? EXITED : ENTERED;
    } else {
      initialStatus = props.unmountOnExit ? UNMOUNTED : EXITED;
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    _this.timer = null;
    return _this;
  }

  _createClass(Transition, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.transitionAppear && this.props.in) {
        this.performEnter(this.props);
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.in && this.props.unmountOnExit) {
        if (this.state.status === UNMOUNTED) {
          // 在componentDidUpdate执行动画.
          this.setState({
            status: EXITED
          });
        }
      } else {
        this._needsUpdate = true;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var status = this.state.status;

      if (this.props.unmountOnExit && status === EXITED) {
        // 当使用unmountOnExit时，exited为exiting和unmont的过渡状态
        if (this.props.in) {
          this.performEnter(this.props);
        } else {
          this.setState({
            status: UNMOUNTED
          });
        }

        return;
      } // 确保只响应prop变化


      if (this._needsUpdate) {
        this._needsUpdate = false;

        if (this.props.in) {
          if (status === EXITING) {
            this.performEnter(this.props);
          } else if (status === EXITED) {
            this.performEnter(this.props);
          } // 其他，当我们已经输入或输出

        } else {
          if (status === ENTERING || status === ENTERED) {
            this.performExit(this.props);
          } // 我们已经输入或输出完成

        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
      this.timer = null;
      this.cancelNextCallback();
    }
  }, {
    key: "performEnter",
    value: function performEnter(props) {
      var _this2 = this;

      this.cancelNextCallback();
      var node = ReactDOM.findDOMNode(this); // 这里接收新props

      props.onEnter(node);
      this.safeSetState({
        status: ENTERING
      }, function () {
        _this2.props.onEntering(node);

        _this2.onTransitionEnd(node, function () {
          _this2.safeSetState({
            status: ENTERED
          }, function () {
            _this2.props.onEntered(node);
          });
        });
      });
    }
  }, {
    key: "performExit",
    value: function performExit(props) {
      var _this3 = this;

      this.cancelNextCallback();
      var node = ReactDOM.findDOMNode(this);
      props.onExit(node);
      this.safeSetState({
        status: EXITING
      }, function () {
        _this3.props.onExiting(node);

        _this3.onTransitionEnd(node, function () {
          _this3.safeSetState({
            status: EXITED
          }, function () {
            _this3.props.onExited(node);
          });
        });
      });
    }
  }, {
    key: "cancelNextCallback",
    value: function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    }
  }, {
    key: "safeSetState",
    value: function safeSetState(nextState, callback) {
      // 确保在组件销毁后挂起的setState被消除
      this.setState(nextState, this.setNextCallback(callback));
    }
  }, {
    key: "setNextCallback",
    value: function setNextCallback(callback) {
      var _this4 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this4.nextCallback = null;
          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    }
  }, {
    key: "onTransitionEnd",
    value: function onTransitionEnd(node, handler) {
      this.setNextCallback(handler);

      if (node) {
        if (transitionEndEvent == undefined) {
          this.nextCallback();
        } else {
          addEventListener(node, transitionEndEvent, this.nextCallback);
        }

        clearTimeout(this.timer);
        this.timer = setTimeout(this.nextCallback, this.props.timeout);
      } else {
        clearTimeout(this.timer);
        this.timer = setTimeout(this.nextCallback, 0);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var status = this.state.status;

      if (status === UNMOUNTED) {
        return null;
      }

      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          childProps = _objectWithoutProperties(_this$props, _excluded);

      Object.keys(Transition.propTypes).forEach(function (key) {
        return delete childProps[key];
      });
      var transitionClassName;

      if (status === EXITED) {
        transitionClassName = this.props.exitedClassName;
      } else if (status === ENTERING) {
        transitionClassName = this.props.enteringClassName;
      } else if (status === ENTERED) {
        transitionClassName = this.props.enteredClassName;
      } else if (status === EXITING) {
        transitionClassName = this.props.exitingClassName;
      }

      var child = React.Children.only(children);
      return /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, childProps), {}, {
        className: classnames(child.props.className, className, transitionClassName)
      }));
    }
  }]);

  return Transition;
}(Component);

Transition.propTypes = propTypes;
Transition.defaultProps = defaultProps;
export default Transition;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-transition/src/Transition.js